import $ from 'jquery';
import {debounce} from 'lodash';
import {breakpointUp, breakpointDown} from './Breakpoints';
import Modal from './Modal'


let RichMenu = {

    OnMenuHover: false,
    elBgOverlay: null,

    init() {

        this.elBgOverlay = $('#bg-overlay');

        // Menu Destinations
        this.richMenuEvents('.nav-bar li.item-destinations', '#menu-destinations');

        // Menu Navires
        this.richMenuEvents('.nav-bar li.item-navires', '#menu-navires');

        // Menu A Propos
        this.richMenuEvents('.nav-bar li.item-apropos', '#menu-apropos');

        this.menuMagazine();
    },
    menuMagazine: function () {

        let body = $('body');
        let navbar = $('.nav-bar');

        body.hasClass('single-post') ? navbar.addClass('magazine-menu') : null;
        body.hasClass('single-travelogue') ? navbar.addClass('magazine-menu') : null;
        body.hasClass('page-template-archive-magazine') ? navbar.addClass('magazine-menu') : null;
        body.hasClass('page-template-hub-nos-thematiques') ? navbar.addClass('magazine-menu') : null;
        body.hasClass('page-template-social-wall') ? navbar.addClass('magazine-menu') : null;
        body.hasClass('category') ? navbar.addClass('magazine-menu') : null;

    },
    richMenuEvents(itemLien, ItemPanel) {

        $(itemLien).hover(() => {
            if (breakpointUp('lg')) {
                this.OnMenuHover = true;
                this.showBgOverlay();
                this.showPanel(ItemPanel);
            }
        }, () => {
            if (breakpointUp('lg')) {
                this.OnMenuHover = false;
                this.hideBgOverlay();
                this.hidePanel(ItemPanel);
            }
        });


        if (itemLien === '.nav-bar li.item-apropos') {
            $(itemLien).on('click', function (event) {
                if (breakpointDown('md') && $(event.target.parentElement).hasClass('item-apropos')) {

                    event.preventDefault();
                    if (!$(this).hasClass('open')) {
                        $(this).find('.nav-rich-wrap').slideDown(300);
                        $(this).addClass('open');
                    } else {
                        $(this).find('.nav-rich-wrap').slideUp(300);
                        $(this).removeClass('open');
                    }
                }
                if(breakpointUp('lg') && $(event.target.parentElement).hasClass('item-apropos')){
                    event.preventDefault();
                }
            });
        }

    },
    showPanel: debounce(function (idPanel) {
        if (this.OnMenuHover) {
            $(idPanel).fadeIn(100);
            $(idPanel).addClass('open');
            $('.nav-bar').addClass('rich-menu-open');
        }
    }, 100),
    hidePanel(idPanel) {
        $(idPanel).hide();
        $(idPanel).removeClass('open');
        $('.nav-bar').removeClass('rich-menu-open');
    },
    showBgOverlay: debounce(function (param, speed = 300, opacity = 0.4) {

        this.elBgOverlay.css('opacity', opacity);

        if (this.OnMenuHover || param === 'modal') {
            if (param === 'modal') {
                this.elBgOverlay.css('z-index', '950');
            }
            this.elBgOverlay.fadeIn(speed);
        }

    }, 100),
    hideBgOverlay: debounce(function (param, speed = 200) {

        if (!this.OnMenuHover && !Modal.modalOpen) {
            this.elBgOverlay.fadeOut(speed);
            if (param === 'modal') {
                setTimeout(() => {
                    this.elBgOverlay.css('z-index', '500');
                }, speed);
            }
        }

    }, 100),

};

export default RichMenu;



// WEBPACK FOOTER //
// ./assets/js/libs/RichMenu.js